/// <amd-module name="Wit/WorkItemForm/Links/Constants" />

export const LinkTopology = {
    Tree: "Tree",
    Dependency: "Dependency",
    DirectedNetwork: "DirectedNetwork",
    Network: "Network"
} as const;

export const GitHubPullRequestState = {
    Open: "open",
    Closed: "closed",
    Merged: "merged"
} as const;

export const GitHubPullReviewDecision = {
    Approved: "approved",
    ReviewRequired: "reviewrequired",
    ChangesRequested: "changesrequested"
} as const;

export const GitHubCheckStatusState = {
    Queued: "queued",
    InProgress: "inprogress",
    Completed: "completed",
    Waiting: "waiting",
    Pending: "pending",
    Requested: "requested"
} as const;

export const GitHubCheckConclusionState = {
    Success: "success",
    Failure: "failure",
    Neutral: "neutral",
    Cancelled: "cancelled",
    TimedOut: "timedout",
    ActionRequired: "actionrequired",
    Stale: "stale",
    Skipped: "skipped",
    StartupFailure: "startupfailure"
} as const;